import { FC, useMemo } from 'react';
import { path } from '../../paths';
import { useNavigateTo } from '../../paths/useNavigateTo';
import { Forbidden } from '../Forbidden';
import { ClassifierForm } from './form/ClassifierForm';
import { useNumericParam } from '../../common/useEntityIdParam';
import { NotFound } from '../NotFound';
import { convertToCloneFormData } from './converters';
import {
  ClassifierFormDataType,
  PermissionCode,
  Spinner,
  useGetClassifierQuery,
  useHasPermission,
} from '@atlas-frontend/sdk';

export const ClassifierClone = () => {
  const classifierId = useNumericParam('id');
  const hasPermission = useHasPermission(PermissionCode.CLASSIFIER_MANAGE);

  if (!classifierId) {
    return <NotFound />;
  }

  return (
    <Forbidden isAllowed={hasPermission}>
      <ClassifierCloneInner classifierId={classifierId} />
    </Forbidden>
  );
};

const ClassifierCloneInner: FC<{ classifierId: number }> = (props) => {
  const { classifierId } = props;
  const { data, isLoading } = useGetClassifierQuery(classifierId);
  const navigateToClassifierEdit = useNavigateTo(path.classifierEdit, {
    id: classifierId,
  });

  const defaultValues: ClassifierFormDataType | undefined = useMemo(
    () => data && convertToCloneFormData(data),
    [data],
  );

  if (isLoading) {
    return <Spinner />;
  }

  if (!defaultValues) {
    return null;
  }

  return (
    <ClassifierForm
      mode="clone"
      defaultValues={defaultValues}
      onClickCancel={() => navigateToClassifierEdit()}
    />
  );
};
